import { SHIPMENT_TRACKING_LEVELS } from '../types'

export const trackingRequirementFullDescription = new Map([
  [
    SHIPMENT_TRACKING_LEVELS.REQUIRED,
    'This shipment must track using either the Transfix App or a 3rd party integration.',
  ],
  [
    SHIPMENT_TRACKING_LEVELS.ENCOURAGED,
    'This shipment needs location tracking, but exception can be made without severe penalty.',
  ],
  [
    SHIPMENT_TRACKING_LEVELS.OPTIONAL,
    'This shipment requires frequent updates which can be satisfied by app tracking.',
  ],
  [SHIPMENT_TRACKING_LEVELS.NONE, 'This shipment does not need tracking.'],
])
